var map = {
	"./bootstrap/select.tpl.html": 454,
	"./select2/select.tpl.html": 455,
	"./selectize/select.tpl.html": 456
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;


//////////////////
// WEBPACK FOOTER
// ./src/app/third/ui-select/src ^\.\/.*\/select\.tpl\.html$
// module id = 453
// module chunks = 0